import { Register } from 'components/Register/Register';

export const RegisterView: React.FC = () => {
    return <Register />;
};
